module.exports = __webpack_public_path__ + "assets/img/block-hover-f0d962a1.png";